import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const clientName = window.env?.REACT_APP_CLIENT || 'greytip'

export const timeDifferenceFromNow = (timestamp: number) => {
  if (!Number.isFinite(timestamp)) {
    return timestamp
  }

  if (!timestamp) {
    return ""
  }

  const msTimestamp = timestamp < 10000000000 ? timestamp * 1000 : timestamp;


  const givenTime = new Date(msTimestamp);

  if (isNaN(givenTime.getTime())) {
    throw new Error("Invalid date: The provided timestamp is not valid");
  }

  const now = new Date();
  const diffMs = now.getTime() - givenTime.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHours = Math.floor(diffMin / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffMonths / 12);

  if (diffYears > 0) {
    return `${diffYears} ${diffYears > 1 ? "years" : "year"} ago`;
  }
  if (diffMonths > 0) {
    return `${diffMonths} ${diffMonths > 1 ? "months" : "month"} ago`;
  }
  if (diffDays > 0) {
    return `${diffDays} ${diffDays > 1 ? "days" : "day"} ago`;
  }
  if (diffHours > 0) {
    return `${diffHours} ${diffHours > 1 ? "hours" : "hour"} ago`;
  }
  if (diffMin > 0) {
    return `${diffMin} ${diffMin > 1 ? "minutes" : "minute"} ago`;
  }
  if (diffSec > 0) {
    return `${diffSec} ${diffSec > 1 ? "seconds" : "second"} ago`;
  }

  return "just now";
};

export const decideColor = (status: string) => {
  switch(status){
    case("CREDIT"):
      return 'text-green-500'
    case("Success"):
      return 'text-green-500'
    case("Failed"):
      return 'text-red-400'
    case("DEBIT"):
      return 'text-red-400'
    default:
      return null
  }
}